function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, onUnmounted, watch, nextTick, onMounted } from "vue";
export default defineComponent({
    props: {
        url: {
            type: String,
            default: ""
        },
        openVideo: {
            type: Boolean,
            default: false
        },
        cors: {
            type: String
        },
        // 是否自动播放
        isAutoPlay: {
            type: Boolean,
            default: true
        },
        // 静音播放
        muted: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props) {
        var videoRef = ref(null);
        var progressRef = ref(null);
        var progressVal = ref(0);
        var vidDuration = ref(0);
        var vidCurrent = ref(0);
        var isPlayVideo = ref(false);
        var loading = ref(true);
        var videoSrc = ref("");
        watch(function() {
            return props.url;
        }, function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(newUrl) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!videoRef.value) {
                                _ctx.next = 9;
                                break;
                            }
                            // 设置 videoSrc 为 '' 并调用 load() 来中止之前的请求
                            videoSrc.value = "";
                            _ctx.next = 4;
                            return nextTick();
                        case 4:
                            videoRef.value.load();
                            _ctx.next = 7;
                            return nextTick();
                        case 7:
                            videoSrc.value = newUrl;
                            videoRef.value.load();
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(newUrl) {
                return _ref.apply(this, arguments);
            };
        }(), {
            immediate: true
        });
        onMounted(function() {
            if (props.url) {
                videoSrc.value = props.url;
            }
        });
        // 视频加载
        var loadeddata = function() {
            loading.value = false;
            isPlayVideo.value = props.isAutoPlay;
            if (videoRef.value && videoRef.value.readyState === 4 && props.isAutoPlay) {
                videoRef.value.play();
            }
        };
        // 播放当前时间改变的时候
        var timeupdate = function() {
            if (videoRef.value && videoRef.value.readyState === 4) {
                vidCurrent.value = videoRef.value.currentTime;
                var percent = vidCurrent.value / vidDuration.value;
                progressVal.value = percent * 100;
            }
        };
        var parentTime = function(value) {
            if (!value) return "";
            var interval = Math.floor(value);
            var minute = Math.floor(interval / 60).toString().padStart(1, "0");
            var second = (interval % 60).toString().padStart(2, "0");
            return "".concat(minute, ":").concat(second);
        };
        // 时长改变的时候
        var durationchange = function() {
            var _$ref;
            vidDuration.value = (_$ref = videoRef.value) === null || _$ref === void 0 ? void 0 : _$ref.duration;
        };
        // 移动进度条
        var changeCurrentTime = function(val) {
            progressVal.value = val;
            videoRef.value.currentTime = val / 100 * videoRef.value.duration;
        };
        // 移动过程中加载
        var seeking = function() {
            // isPlayVideo.value = false
            loading.value = true;
        };
        // 移动加载结束
        var seeked = function() {
            // isPlayVideo.value = true
            loading.value = false;
        };
        // 播放完毕
        var ended = function() {
            isPlayVideo.value = false;
        };
        var formTime = computed(function() {
            if (parentTime(vidCurrent.value)) {
                return " ".concat(parentTime(vidCurrent.value), " / ").concat(parentTime(vidDuration.value));
            } else if (!parentTime(vidDuration.value)) {
                return "0:00 / 0:00";
            }
            return "0:00 / ".concat(parentTime(vidDuration.value));
        });
        var isVideoPalyOrPause = function(val) {
            if (val) {
                videoRef.value.pause();
                isPlayVideo.value = false;
            } else {
                videoRef.value.play();
                isPlayVideo.value = true;
            }
        };
        var handlePlay = function() {
            isVideoPalyOrPause(isPlayVideo.value);
        };
        onUnmounted(function() {
            if (videoRef.value) {
                // 设置 src 为 '' 并调用 load() 来中止任何正在进行的请求
                videoRef.value.src = "";
                videoRef.value.load();
            }
        });
        var handlePause = function() {
            videoRef.value.pause();
            isPlayVideo.value = false;
        };
        var handlePauseIcon = function() {
            isPlayVideo.value = false;
        };
        return {
            videoRef: videoRef,
            timeupdate: timeupdate,
            durationchange: durationchange,
            formTime: formTime,
            handlePlay: handlePlay,
            isPlayVideo: isPlayVideo,
            changeCurrentTime: changeCurrentTime,
            seeking: seeking,
            seeked: seeked,
            loading: loading,
            ended: ended,
            progressVal: progressVal,
            loadeddata: loadeddata,
            progressRef: progressRef,
            handlePause: handlePause,
            handlePauseIcon: handlePauseIcon,
            videoSrc: videoSrc
        };
    }
});
